// import React from "react";
// import { NavLink, useLocation } from "react-router-dom";
// import { TbLayoutDashboardFilled } from "react-icons/tb";
// import { MdGroups } from "react-icons/md";
// import { FaUserLarge } from "react-icons/fa6";
// import { RiShoppingBag3Fill } from "react-icons/ri";
// import { IoChatbubbles } from "react-icons/io5";
// import { IoIosLogOut } from "react-icons/io";

// const AdminSidebar = () => {
//   const location = useLocation(); // Get the current URL

//   return (
//     <div className="relative h-full flex flex-col">
//       {/* Sidebar for larger screens */}
//       <div className="flex flex-col items-start w-full flex-grow">
//         <div className="w-full flex justify-center items-center my-6">
//           <img src="/images/logo/navlogo.png" alt="Logo" className="w-5/6" />
//         </div>
//         <ul className="space-y-4 w-full text-lg font-bold">
//           <li
//             className={`flex items-center space-x-2 p-2 w-full transform transition-all duration-300 ${location.pathname === "/admin_dashboard"
//               ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC] text-brand-primary"
//               : "hover:text-brand-primary hover:bg-[#CDF2CC]"}`
//             }
//           >
//             <NavLink
//               to="/admin_dashboard"
//               className={({ isActive }) => `flex items-center space-x-2 w-full ${isActive ? "text-brand-primary" : "text-gray-700"}`}
//             >
//               <TbLayoutDashboardFilled />
//               <span>Dashboard</span>
//             </NavLink>
//           </li>
//           <li
//             className={`flex items-center space-x-2 p-2 w-full transform transition-all duration-300 ${location.pathname === "/admin_sellers"
//               ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC] text-brand-primary"
//               : "hover:text-brand-primary hover:bg-[#CDF2CC]"}`
//             }
//           >
//             <NavLink
//               to="/admin_sellers"
//               className={({ isActive }) => `flex items-center space-x-2 w-full ${isActive ? "text-brand-primary" : "text-gray-700"}`}
//             >
//               <MdGroups />
//               <span>Seller</span>
//             </NavLink>
//           </li>
//           <li
//             className={`flex items-center space-x-2 p-2 w-full transform transition-all duration-300 ${location.pathname === "/admin_customers"
//               ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC] text-brand-primary"
//               : "hover:text-brand-primary hover:bg-[#CDF2CC]"}`
//             }
//           >
//             <NavLink
//               to="/admin_customers"
//               className={({ isActive }) => `flex items-center space-x-2 w-full ${isActive ? "text-brand-primary" : "text-gray-700"}`}
//             >
//               <FaUserLarge />
//               <span>Customers</span>
//             </NavLink>
//           </li>
//           <li
//             className={`flex items-center space-x-2 p-2 w-full transform transition-all duration-300 ${location.pathname === "/admin_products"
//               ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC] text-brand-primary"
//               : "hover:text-brand-primary hover:bg-[#CDF2CC]"}`
//             }
//           >
//             <NavLink
//               to="/admin_products"
//               className={({ isActive }) => `flex items-center space-x-2 w-full ${isActive ? "text-brand-primary" : "text-gray-700"}`}
//             >
//               <RiShoppingBag3Fill />
//               <span>Products</span>
//             </NavLink>
//           </li>
//           <li
//             className={`flex items-center space-x-2 p-2 w-full transform transition-all duration-300 ${location.pathname === "/admin_feedbacks"
//               ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC] text-brand-primary"
//               : "hover:text-brand-primary hover:bg-[#CDF2CC]"}`
//             }
//           >
//             <NavLink
//               to="/admin_feedbacks"
//               className={({ isActive }) => `flex items-center space-x-2 w-full ${isActive ? "text-brand-primary" : "text-gray-700"}`}
//             >
//               <IoChatbubbles />
//               <span>Feedbacks</span>
//             </NavLink>
//           </li>
//         </ul>
//       </div>

//       {/* Logout section */}
//       <div className="p-4 flex flex-row w-full mt-auto">
//         <NavLink
//           to="/admin_logout"
//           className="flex items-center space-x-2 text-brand-text-light font-semibold hover:text-red-700 w-full"
//         >
//           <IoIosLogOut className="text-2xl"/>
//           <span>Logout</span>
//         </NavLink>
//       </div>
//     </div>
//   );
// };

// export default AdminSidebar;

import React, { useState, useMemo, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  TbFlag3,
  TbLayoutDashboardFilled,
  TbTruckDelivery,
} from "react-icons/tb";
import {
  MdApproval,
  MdGroups,
  MdLocalOffer,
  MdOutlinePointOfSale,
  MdOutlineVerifiedUser,
  MdHistory,
} from "react-icons/md";
import {
  FaChartLine,
  FaCommentDots,
  FaFolderPlus,
  FaHouseUser,
  FaProductHunt,
  FaSitemap,
  FaTags,
  FaUserCheck,
  FaUserLarge,
  FaUserPlus,
  FaUserTag,
} from "react-icons/fa6";
import { RiAdvertisementLine, RiShoppingBag3Fill } from "react-icons/ri";
import { IoCard, IoChatbubbles, IoCheckmarkDoneSharp } from "react-icons/io5";
import { IoIosLogOut } from "react-icons/io";
import { AiFillCaretDown, AiFillCaretUp, AiOutlineFolderView } from "react-icons/ai";
import {
  FaUsers,
  FaUserTie,
  FaUserShield,
  FaPlusCircle,
  FaRegListAlt,
} from "react-icons/fa";
import { HiOutlineBadgeCheck, HiOutlineDocumentReport } from "react-icons/hi";
import { MdOutlineGroup } from "react-icons/md";
import { MdAttribution } from "react-icons/md";
import { PiUsersThreeFill } from "react-icons/pi";
import { SiGithubsponsors } from "react-icons/si";
import { useAuth } from "../../context/AuthContext";

const menuItems = [
  {
    label: "Dashboard",
    path: "/subadmin",
    icon: <TbLayoutDashboardFilled />,
  },
  {
    label: "Orders",
    icon: <IoCard />,
    submenu: [
      {
        label: "Orders View",
        path: "/subadmin/orders/view_orders",
        icon: <AiOutlineFolderView />,
      },
    ],
  },
  {
    label: "Sales",
    path: "/subadmin/sales",
    icon: <FaChartLine />,
  },
  {
    label: "Report",
    icon: <TbFlag3 />,
    submenu: [
      {
        label: "Report Overall",
        path: "/subadmin/report/overall",
        icon: <HiOutlineDocumentReport />,
      },
      { label: "Sales Report", path: "/subadmin/report/sales", icon: <MdOutlinePointOfSale /> },
      {
        label: "Delivery Report",
        path: "/subadmin/report/delivery",
        icon: <TbTruckDelivery />,
      },
      {
        label: "Order Report",
        path: "/subadmin/report/orders",
        icon: <IoCard />,
      },
    ],
  },
  {
    label: "Sellers",
    path: "/subadmin/sellers",
    icon: <MdGroups />,
  },
  {
    label: "Customers",
    path: "/subadmin/customers",
    icon: <FaUserLarge />,
  },
  {
    label: "Revenue",
    icon: <MdOutlinePointOfSale />,
    submenu: [
      {
        label: "Revenue Dashboard",
        path: "/subadmin/revenue",
        icon: <TbLayoutDashboardFilled />,
        exact: true
      },
      {
        label: "Transaction History",
        path: "/subadmin/revenue/transactions",
        icon: <MdHistory /> // Note: MdHistory needs to be imported if not already allowed via existing imports or add it.
      }
    ]
  },
  // {
  //     label: "Sub Admin Allocation",
  //     icon: <FaUserShield />,
  //     submenu: [
  //         {
  //             label: "Customer Allocation",
  //             path: "allocation/customer",
  //             icon: <FaHouseUser />,
  //         },
  //         {
  //             label: "Seller Allocation",
  //             path: "allocation/seller",
  //             icon: <MdOutlineVerifiedUser />,
  //         },
  //     ],
  // },
];

// Updated active check that respects the 'exact' property
const checkItemActive = (item, currentPath) => {
  if (item.path) {
    if (item.exact) {
      if (currentPath === item.path) {
        return true;
      }
    } else {
      if (currentPath.startsWith(item.path)) {
        return true;
      }
    }
  }
  if (item.submenu) {
    return item.submenu.some((subItem) => checkItemActive(subItem, currentPath));
  }
  return false;
};

// Recursive function to get all active paths for a given location
const getActivePaths = (items, currentPath, parentPath = "") => {
  let activePaths = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const currentKeyPath = parentPath ? `${parentPath}-${i}` : `${i}`;

    if (item.path) {
      // Use exact match if 'exact' flag is present; otherwise, startsWith check.
      if (item.exact && currentPath === item.path) {
        activePaths.push(currentKeyPath);
      } else if (!item.exact && currentPath.startsWith(item.path)) {
        activePaths.push(currentKeyPath);
      }
    }

    if (item.submenu && item.submenu.length > 0) {
      const subActivePaths = getActivePaths(item.submenu, currentPath, currentKeyPath);
      if (subActivePaths.length > 0) {
        activePaths.push(currentKeyPath);
        activePaths = [...activePaths, ...subActivePaths];
      }
    }
  }

  return activePaths;
};

const MenuItem = ({ item, keyPath, depth, toggleDropdown, dropdownStates, location }) => {
  const hasSubmenu = item.submenu && item.submenu.length > 0;
  const isOpen = dropdownStates[keyPath] || false;

  const isActive = useMemo(() => checkItemActive(item, location.pathname), [item, location.pathname]);

  const handleClick = (e) => {
    if (hasSubmenu) {
      e.preventDefault();
      toggleDropdown(keyPath);
    }
  };

  return (
    <li className="flex w-full flex-col">
      <NavLink
        to={hasSubmenu ? "/" : item.path || "/"}
        onClick={handleClick}
        className={({ isActive: isNavActive }) =>
          `flex items-center transition-all duration-300 ${isActive || isNavActive ? "" : "text-gray-700 hover:text-brand-primary"
          }`
        }
      >
        <div
          className={`flex w-full cursor-pointer items-center justify-between transition-all duration-300 my-[2px] ${isActive
            ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC]"
            : "hover:bg-[#CDF2CC]"
            }`}
          style={{
            padding: "0.5rem",
            paddingLeft: depth === 0 ? "0.5rem" : `${depth * 1.5}rem`,
          }}
        >
          <div className="flex items-center space-x-2">
            {item.icon}
            <span>{item.label}</span>
          </div>
          {hasSubmenu && (isOpen ? <AiFillCaretUp /> : <AiFillCaretDown />)}
        </div>
      </NavLink>

      {hasSubmenu && isOpen && (
        <ul className="space-y-2 transition duration-500 ease-in-out">
          {item.submenu.map((subItem, subIndex) => (
            <MenuItem
              key={subIndex}
              item={subItem}
              keyPath={`${keyPath}-${subIndex}`}
              depth={depth + 1}
              toggleDropdown={toggleDropdown}
              dropdownStates={dropdownStates}
              location={location}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const SubAdminSidebar = () => {
  const location = useLocation();
  const [dropdownStates, setDropdownStates] = useState({});
  const { logout } = useAuth();

  // Initialize dropdown states based on current path
  useEffect(() => {
    const activePaths = getActivePaths(menuItems, location.pathname);
    const newDropdownStates = {};

    // Set active paths to open
    activePaths.forEach((path) => {
      newDropdownStates[path] = true;
    });

    setDropdownStates(newDropdownStates);
  }, [location.pathname]);

  const toggleDropdown = (keyPath) => {
    setDropdownStates((prev) => {
      const newState = { ...prev };
      const pathSegments = keyPath.split("-");

      // If closing a submenu, close all its children
      if (newState[keyPath]) {
        Object.keys(newState).forEach((key) => {
          if (key.startsWith(keyPath + "-")) {
            newState[key] = false;
          }
        });
      } else {
        // If opening a submenu, close siblings at the same level
        if (pathSegments.length > 1) {
          const parentPath = pathSegments.slice(0, -1).join("-");
          Object.keys(newState).forEach((key) => {
            if (key.startsWith(parentPath + "-") && key !== keyPath && !key.startsWith(keyPath + "-")) {
              newState[key] = false;
            }
          });
        } else {
          Object.keys(newState).forEach((key) => {
            if (key.indexOf("-") === -1 && key !== keyPath) {
              newState[key] = false;
            }
          });
        }
      }
      // Toggle the current item
      newState[keyPath] = !newState[keyPath];
      return newState;
    });
  };

  return (
    <div className="relative flex h-full flex-col border-r border-gray-200 bg-white">
      <div className="my-6 flex w-full items-center justify-center">
        <img src="/images/logo/navlogo.png" alt="Logo" className="w-5/6" />
      </div>
      <div className="flex w-full flex-grow flex-col items-start overflow-x-auto">
        <ul className="w-full space-y-4 text-[15px] font-semibold">
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              item={item}
              keyPath={`${index}`}
              depth={0}
              toggleDropdown={toggleDropdown}
              dropdownStates={dropdownStates}
              location={location}
            />
          ))}
        </ul>
        <div className="mt-2 px-2 py-2">
          <NavLink
            onClick={logout}
            to="/"
            className="flex w-full items-center space-x-2 font-semibold text-brand-text-light hover:text-red-700"
          >
            <IoIosLogOut className="text-xl" />
            <span>Logout</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};


export default SubAdminSidebar